import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import axios from 'axios'
const api = '/api/'

export const ListTransportPayment = createAsyncThunk(
  'student-transport-payments-list',
  async (params: {}, thunkAPI) => {
    try {
      const response = await axios.get(`${api}student-transport-payments/list`, params)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Get Transport StudentList
export const ListTransportStudent = createAsyncThunk(
  'student-transport-payments-list',
  async (_, thunkAPI) => {
    try {
      const response = await axios.get(
        `${api}student-transport-payments/get-students-has-transport`
      )
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const getTransportPaymentDetails = createAsyncThunk(
  'student-transport-payments-details',
  async (student_id: any, thunkAPI) => {
    try {
      const response = await axios.get(
        `${api}student-transport-payments/student-details/` + student_id
      )
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data)
      }
    }
  }
)

export const transportPaymentStore = createAsyncThunk(
  'student-transport-payments-store',
  async (companyData: any, thunkAPI) => {
    try {
      const {data} = await axios.post(`${api}student-transport-payments/store`, companyData)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors)
    }
  }
)

export const editTransportPayment = createAsyncThunk(
  'student-transport-payments-edit',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`/api/student-transport-payments/edit/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const studentPayments = createAsyncThunk(
  'student-transport-payments',
  async (params: {student_id: string; year: string}, thunkAPI) => {
    try {
      const response = await axios.get(
        `${api}student-transport-payments/student-transport-payments`,
        {
          params, // ✅ correct axios GET params
        }
      )
      return response.data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors)
    }
  }
)

export const printTransportPayment = createAsyncThunk(
  'student-transport-payments-print',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`${api}student-transport-payments/print/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const deleteTransportPayment = createAsyncThunk(
  'student-transport-payments-delete',
  async (id: string, thunkAPI) => {
    try {
      await axios.get(`${api}student-transport-payments/delete/${id}`)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const dphsTransportPaymentStore = createAsyncThunk(
  'dphs-transport-payment-store',
  async (companyData: any, thunkAPI) => {
    try {
      const {data} = await axios.post(
        `${api}student-transport-payments/dphs-transport-payment`,
        companyData
      )
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors)
    }
  }
)

export const getStudentTransportReport = createAsyncThunk(
  'get-student-transport-report',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post(
        `${api}student-transport-payments/get-student-transport-report`,
        data
      )
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const printStudentTransportReport = createAsyncThunk(
  'print-student-transport-report',
  async (params: {}, thunkAPI) => {
    try {
      const response = await axios.get(
        `${api}student-transport-payments/print-student-transport-report`,
        {
          params,
        }
      )

      return response.data
    } catch (error: any) {
      if (error.response?.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const studentTransportExcelReport = createAsyncThunk(
  'student-transport-excel-report',
  async (params: {}, thunkAPI) => {
    try {
      const response = await axios.get(
        `${api}student-transport-payments/student-transport-excel-report`,
        {
          params,
          responseType: 'blob',
        }
      )
      return response.data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors || 'Something went wrong')
    }
  }
)

export const studentTransportDetails = createAsyncThunk(
  'student-transport-payments-details',
  async (student_transport_payment_id: any, thunkAPI) => {
    try {
      const response = await axios.get(
        `${api}student-transport-payments/details/` + student_transport_payment_id
      )
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data)
      }
    }
  }
)

export const transportPaymentSummary = createAsyncThunk(
  'student-transport-payments-transport-payment-summary',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post(
        `${api}student-transport-payments/transport-payment-summary`,
        data
      )
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const transportPaymentChart = createAsyncThunk(
  'student-transport-payments-transport-payment-chart',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post(
        `${api}student-transport-payments/transport-payment-chart`,
        data
      )
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const getUnpaidStudentTransportReport = createAsyncThunk(
  'get-unpaid-student-transport-report',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post(
        `${api}student-transport-payments/get-unpaid-student-transport-report`,
        data
      )
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const printUnpaidStudentTransportReport = createAsyncThunk(
  'print-student-transport-report',
  async (params: {}, thunkAPI) => {
    try {
      const response = await axios.get(
        `${api}student-transport-payments/print-unpaid-student-transport-report`,
        {
          params,
        }
      )

      return response.data
    } catch (error: any) {
      if (error.response?.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const unpaidStudentTransportExcelReport = createAsyncThunk(
  'student-transport-excel-report',
  async (params: {}, thunkAPI) => {
    try {
      const response = await axios.get(
        `${api}student-transport-payments/unpaid-student-transport-excel-report`,
        {
          params,
          responseType: 'blob',
        }
      )
      return response.data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors || 'Something went wrong')
    }
  }
)

export const emptyTransportFormPrint = createAsyncThunk(
  'print-empty-student-transport-form',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(
        `${api}student-transport-payments/print-empty-student-transport-form/${id}`
      )
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

type TransportPaymentState = {
  errors: any
}

const initialState: TransportPaymentState = {
  errors: '',
}

export const studentTransportPayments = createSlice({
  name: 'transport_payments',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {},
})

export const {reset} = studentTransportPayments.actions
export default studentTransportPayments.reducer
